

  export const swarnAppMainUrl = 'https://adminapi.swarnapp.com/'
   
   // svg logo url path 
  export const swarnAppLoginLogoPath  = 'assets/images/svg/swarnApp-logos/SwarnAppLogin-logo.svg';
  export const swarnAppLoginRightLogoPath  = 'assets/images/svg/swarnApp-logos/SwarnAppLogin-right-logo.svg';
  export const swarnAppHeaderLogoPath = "assets/images/svg/swarnApp-logos/SwarnAppHeader-logo.svg";

  export const jewelstepsLoginLogoPath  = 'assets/images/svg/jewelsteps-logos/JewelstepsLogin-logo.svg';
  export const jewelstepsLoginRightLogoPath  = 'assets/images/svg/jewelsteps-logos/JewelstepsLogin-right-logo.svg';
  export const jewelstepsHeaderLogoPath = "assets/images/svg/jewelsteps-logos/JewelstepsHeader-logo.svg";
